import { format } from 'date-fns';
import { motion } from 'framer-motion';
import { Card, Typography, Box } from '@mui/material';

const NewsCard = ({ image, title, date, content, onClick, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.1, ease: [0.16, 1, 0.3, 1] }}
    >
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          borderRadius: '24px',
          overflow: 'hidden',
          position: 'relative',
          bgcolor: '#0f172a',
          aspectRatio: { xs: '16/9', sm: '4/5' },
          transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
          '&:hover': {
            transform: 'translateY(-12px)',
            boxShadow: '0 40px 80px rgba(0,0,0,0.25)',
            zIndex: 2,
            '& .card-image': { transform: 'scale(1.1)', opacity: 0.8 },
            '& .overlay-box': { bgcolor: 'rgba(0,0,0,0.2)' }
          }
        }}
        onClick={() => onClick()}
      >
        <Box
          className="card-image"
          component="img"
          src={image}
          alt={title}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            transition: 'all 1s cubic-bezier(0.16, 1, 0.3, 1)'
          }}
        />

        <Box
          className="overlay-box"
          sx={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.95) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            p: { xs: 3, md: 4 },
            transition: 'all 0.4s ease'
          }}
        >
          {/* Floating Date Tag */}
          <Box
            sx={{
              position: 'absolute',
              top: 24,
              right: 24,
              bgcolor: 'rgba(15, 23, 42, 0.9)',
              backdropFilter: 'blur(8px)',
              px: 1.5,
              py: 0.8,
              borderRadius: '8px',
              border: '1px solid rgba(255,255,255,0.1)',
              zIndex: 1,
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#fbbf24', boxShadow: '0 0 8px #fbbf24' }} />
            <Typography sx={{ color: '#fff', fontSize: '0.65rem', fontWeight: 900, letterSpacing: 1.5 }}>
              {format(new Date(date), 'dd MMM yyyy').toUpperCase()}
            </Typography>
          </Box>

          <Typography
            variant="h4"
            sx={{
              color: '#ffffff',
              fontFamily: 'Bebas Neue',
              lineHeight: 1,
              letterSpacing: '0.5px',
              textTransform: 'uppercase',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              fontSize: {
                xs: 'clamp(1.2rem, 2vw, 1.5rem)',
                md: 'clamp(1.5rem, 2vw, 1.8rem)'
              },
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              mt: 1,
              color: 'rgba(255,255,255,1)',
              fontSize: {
                xs: 'clamp(0.85rem, 2vw, 1rem)',
                md: 'clamp(0.8rem, 1vw, 1rem)'
              },
              lineHeight: 1.6,
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {content}
          </Typography>
        </Box>
      </Card>
    </motion.div>
  );
};

export default NewsCard;
